import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, Banner, SettingToggle, Text, Checkbox, LegacyStack, Select, PageActions,Icon } from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { fetchApi } from './helpers/fetchApi';
import { InfoMinor } from '@shopify/polaris-icons';
import { isBannerDismissed, dismissBanner } from './helpers/bannerSession';
import { GlobalPlanBanners } from './GlobalPlanBanners';

export class StickyCart extends Component {

    constructor(props) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);

        this.state = { initState: {}, model: {}, loading: true, previewActive: true, showFreePlanBanner: true };
    }

    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
    }
    
    discardChanges(){
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });
    }

    render() {

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Sticky Cart">
                    <Layout>
                        <Layout.Section>
                            <GlobalPlanBanners common={this.props.common} url={window.location.search} />
                        </Layout.Section>
                        <Layout.Section

                        >
                            <Card>
                                <Card.Section>
                                    <LegacyStack alignment="leading" spacing="tight">
                                    <LegacyStack.Item>
                                        <Icon source={InfoMinor} />
                                    </LegacyStack.Item>

                                    <LegacyStack.Item>
                                        <Text as="h3" variant="headingSm">
                                        What is Sticky cart?
                                        </Text>
                                    </LegacyStack.Item>

                                    <LegacyStack.Item fill>
                                        <div style={{ marginTop: 4 }}>
                                        <Text as="p" variant="bodyMd">
                                            Sticky Cart is a floating cart bubble that remains visible on the screen.
                                            It allows customers to quickly open their cart and proceed to checkout
                                            without needing to scroll or navigate away from the current page.
                                        </Text>
                                        </div>
                                    </LegacyStack.Item>
                                    </LegacyStack>
                                </Card.Section>
                            </Card>
                            {/* <Banner
                                title="What is Sticky cart?"
                                status="info"
                            >
                                <p>Sticky cart is a bubble cart that is always visible making easier for customers to checkout.</p>
                            </Banner> */}
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className={this.state.previewActive ? '' : 'preview-hidden'}>
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    <div id="satcb_sticky_cart" style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                        <a href="/#" onClick={(e) => e.preventDefault()} className="animated bounceIn" style={{
                                            left: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? 'auto' : '0',
                                            right: this.state.model.position === 'top_right' || this.state.model.position === 'bottom_right' ? '0' : 'auto',
                                            top: this.state.model.position === 'top_right' || this.state.model.position === 'top_left' ? '0' : 'auto',
                                            bottom: this.state.model.position === 'bottom_right' || this.state.model.position === 'bottom_left' ? '0' : 'auto'
                                        }}>
                                            <span className={this.state.model.stickyCartIcon ? "glyphicon" : "glyphicon glyphicon-shopping-cart"} style={{ backgroundColor: this.state.model.backgroundColor, color: this.state.model.iconColor }}>
                                                {this.state.model.stickyCartIcon ? <img id='satcb_sticky_cart_icon' src={this.state.model.stickyCartIcon} width='30' height='30' alt='SATCB sticky cart icon' /> : ""}
                                                <mark style={{ backgroundColor: this.state.model.totalQuantityBackgroundColor, color: this.state.model.totalQuantityTextColor }}>7</mark>
                                            </span>
                                        </a>
                                    </div>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Sticky cart state"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Sticky cart is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="General settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Show on tablets and mobile devices"
                                        checked={this.state.model.showOnMobile}
                                        onChange={(newValue) => this.handleChange('showOnMobile', newValue)}
                                    />
                                    <Checkbox
                                        label="Show on desktop computers"
                                        checked={this.state.model.showOnDesktop}
                                        onChange={(newValue) => this.handleChange('showOnDesktop', newValue)}
                                    />
                                    <Checkbox
                                        label="Hide Sticky Cart on Cart page"
                                        checked={this.state.model.hideOnCartPage}
                                        onChange={(newValue) => this.handleChange('hideOnCartPage', newValue)}
                                    />
                                    <Checkbox
                                        label="Hide Sticky Cart if there are no items in the cart"
                                        checked={this.state.model.hideWhenEmpty}
                                        onChange={(newValue) => this.handleChange('hideWhenEmpty', newValue)}
                                    />
                                    <LegacyStack>
                                        <Checkbox
                                            label="Show add to sticky cart animation"
                                            checked={this.state.model.animateATC}
                                            onChange={(newValue) => this.handleChange('animateATC', newValue)}
                                            helpText="Product image will smoothly transition to Sticky Cart on add to cart event"
                                        />
                                    </LegacyStack>
                                    <Select
                                        label="Position"
                                        options={[{ label: 'Top Right', value: 'top_right' }, { label: 'Bottom Right', value: 'bottom_right' }, { label: 'Top Left', value: 'top_left' }, { label: 'Bottom Left', value: 'bottom_left' }]}
                                        onChange={(newValue) => this.handleChange('position', newValue)}
                                        value={this.state.model.position}
                                    />
                                    <Select
                                        label="Click on Sticky Cart redirects"
                                        options={[{ label: 'To Checkout when on Cart page otherwise to Cart', value: '' }, { label: 'To Cart', value: '/cart' }, { label: 'To Checkout', value: '/checkout' }]}
                                        onChange={(newValue) => this.handleChange('postAction', newValue)}
                                        value={this.state.model.postAction}
                                    />
                                    <FormLayout.Group>
                                        <label>Cart icon (30x30) <small><b></b></small> <br />
                                            <input id="stickyCartIcon" type="file" className="Polaris-Button" accept="image/*" onClick={() => document.querySelector('#stickyCartIcon').value = ""} onChange={() => {
                                                setTimeout(async () => {

                                                    const toBase64 = file => new Promise((resolve, reject) => {
                                                        const reader = new FileReader();
                                                        reader.readAsDataURL(file);
                                                        reader.onload = () => {
                                                            if (file.size > 4096) {
                                                                alert('Cart icon file size should not be greater than 4kb');
                                                                resolve("");
                                                                return;
                                                            }
                                                            resolve(reader.result);
                                                        };
                                                        reader.onerror = error => reject(error);
                                                    });
                                                    
                                                    if (document.querySelector('#stickyCartIcon').files.length > 0) {
                                                        const file = document.querySelector('#stickyCartIcon').files[0];
                                                        var cartIconBase64 = await toBase64(file);
                                                        this.setState(prevState => {
                                                            let model = Object.assign({}, prevState.model);
                                                            model.stickyCartIcon = cartIconBase64;
                                                            return { model };
                                                        })

                                                    } else {
                                                        this.setState(prevState => {
                                                            let model = Object.assign({}, prevState.model);
                                                            model.stickyCartIcon = "";
                                                            return { model };
                                                        })
                                                    }
                                                }, 500);
                                                
                                            }
                                            } />
                                        </label>

                                        <span>
                                            <br />
                                            <button className="Polaris-Button" onClick={() => {
                                                this.setState(prevState => {
                                                    let model = Object.assign({}, prevState.model);  
                                                    model.stickyCartIcon = '';                     
                                                    return { model };                              
                                                })
                                            }}>Reset cart icon</button>
                                        </span>
                                    </FormLayout.Group>

                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Look and feel"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Background color"
                                            fieldName="backgroundColor"
                                            value={this.state.model.backgroundColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label="Icon color"
                                            fieldName="iconColor"
                                            value={this.state.model.iconColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <ColorPickerCustom
                                            label="Total quantity text color"
                                            fieldName="totalQuantityTextColor"
                                            value={this.state.model.totalQuantityTextColor}
                                            handleChange={this.handleChange}
                                        />
                                        <ColorPickerCustom
                                            label="Total quantity background color"
                                            fieldName="totalQuantityBackgroundColor"
                                            value={this.state.model.totalQuantityBackgroundColor}
                                            handleChange={this.handleChange}
                                        />
                                    </FormLayout.Group>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                            {/*{window.innerWidth < 768 ? */}
                            {/*<LegacyStack alignment="center" distribution="center">*/}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*</LegacyStack>    */}
                            {/*: */}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*}*/}
                        </Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                        <Layout.Section></Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/stickyCart');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function(){
                window?.$('#preview')?.sticky({ topSpacing: 0, zIndex: 100 });
                window?.$('#preview')?.sticky('update');
            },100);
            
            window.$('#satcb_sticky_cart a').click(function (e) {
                e.preventDefault();
            });
            window.$("#satcb_sticky_cart a").hover(function () {
                window.$("#satcb_sticky_cart mark").satcb_animateCss('swing');
            });
        }
    }

    async saveChanges() {
        
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveStickyCart', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }
}